const UserRoles = {
    ADMIN:              1,
    RENTAL_MANAGER:     2,
    RENTAL_EMPLOYEE:    3,
    MOORAGE_MANAGER:    4,
    MOORAGE_EMPLOYEE:   5
}

export default UserRoles
